"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _routeHighlightChecker = _interopRequireDefault(require("../../utils/routeHighlightChecker"));
var _excluded = ["route", "i", "onNavigate", "rootItem"];
/* eslint-disable react/jsx-props-no-spreading */
var Wrapper = (0, _styledComponents["default"])(_components.MotionFlex).withConfig({
  displayName: "SingleNavItem__Wrapper",
  componentId: "sc-1t8rq0y-0"
})(["cursor:pointer;"]);

/**
 * A nav item for a route without any child routes. This component
 * is **mobile-only**.
 * @param {object} props React components passed in props.
 * @param {object} props.route The route to render a nav item for.
 * @param {function} props.onNavigate An event to be fired when the nav item is clicked.
 * @param {boolean} props.rootItem If nav item a root navigation route.AbortController
 * @param {any} props.props Passed styled props to the nav text item.
 * @package
 */
var SingleNavItem = function SingleNavItem(_ref) {
  var route = _ref.route,
    _ref$i = _ref.i,
    i = _ref$i === void 0 ? 0 : _ref$i,
    onNavigate = _ref.onNavigate,
    rootItem = _ref.rootItem,
    props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var _useNavContext = (0, _useNavContext2["default"])(),
    fontFamilies = _useNavContext.fontFamilies,
    navbarItemColor = _useNavContext.navbarItemColor,
    tabBarItemColor = _useNavContext.tabBarItemColor;
  var shouldHighlight = (0, _routeHighlightChecker["default"])(route);
  var variants = {
    hidden: {
      translateY: -50 * i + "px",
      transition: {
        ease: "easeInOut",
        duration: 0.2
      }
    },
    visible: {
      translateY: "0px",
      transition: {
        ease: "easeInOut",
        duration: 0.2
      }
    }
  };
  var decideColor = function decideColor() {
    if (shouldHighlight) {
      return rootItem ? navbarItemColor.selected : tabBarItemColor.selected || navbarItemColor.selected;
    }
    return rootItem ? navbarItemColor.unSelected : tabBarItemColor.unSelected || navbarItemColor.unSelected;
  };
  return !route["private"] && /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
    to: route.path,
    external: route.path.includes("#")
  }, route.linkProps), /*#__PURE__*/_react["default"].createElement(Wrapper, {
    width: "auto",
    height: "50px",
    alignItems: "center",
    pr: 3,
    pl: 3,
    onClick: onNavigate,
    variants: rootItem ? {} : variants
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, (0, _extends2["default"])({}, props, {
    fontFamily: shouldHighlight ? fontFamilies === null || fontFamilies === void 0 ? void 0 : fontFamilies.selected : fontFamilies === null || fontFamilies === void 0 ? void 0 : fontFamilies.unSelected,
    fontWeight: 700,
    color: decideColor()
  }), route.navbarDescription || route.description)));
};
var _default = exports["default"] = SingleNavItem;